import axios from "axios";
import { baseUrl, Base_Url_Landing_Page_Frontend } from "./baseUri";

const API = axios.create({
  baseURL: baseUrl,
});

// Attach token to headers
API.interceptors.request.use((req) => {
  try {
    const userStr = sessionStorage.getItem("interview-user") || localStorage.getItem("interview-user");
    if (userStr) {
      const user = JSON.parse(userStr);
      const token = user?.token;
      if (token) req.headers.Authorization = `Bearer ${token}`;
    }
  } catch (e) {
    console.error("Error reading token from storage:", e);
  }
  return req;
});

// Response interceptor: Automatic session extension on 401
let isExtending = false;
let extendQueue = [];

const processExtendQueue = (error, token = null) => {
  extendQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  extendQueue = [];
};

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If 401 Unauthorized and not already retrying
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isExtending) {
        return new Promise((resolve, reject) => {
          extendQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return API(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isExtending = true;

      try {
        const userStr = sessionStorage.getItem("interview-user") || localStorage.getItem("interview-user");
        const user = userStr ? JSON.parse(userStr) : null;
        const currentToken = user?.token;

        const res = await axios.post(
          `${baseUrl}/api/verify/extend-session`,
          {},
          {
            headers: {
              Authorization: `Bearer ${currentToken}`,
            },
          }
        );

        const newToken = res.data?.token;
        if (newToken && user) {
          user.token = newToken;
          sessionStorage.setItem("interview-user", JSON.stringify(user));
          localStorage.removeItem("interview-user");

          processExtendQueue(null, newToken);

          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return API(originalRequest);
        }
      } catch (extendErr) {
        processExtendQueue(extendErr, null);
        console.error("Session extension failed:", extendErr);
        // Only redirect if absolutely cannot recover
      } finally {
        isExtending = false;
      }
    }

    return Promise.reject(error);
  }
);

export default API;